import React, { useState, useEffect, useRef } from 'react';
import ProtectedRoute from '../../routes/protected';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useParams } from 'react-router-dom';
import performanceService from '../../services/data/performance.service';
import { Toast } from 'primereact/toast';
import moment from "moment";
import 'moment/locale/pt-br'
import { Avatar } from 'primereact/avatar';
import NameInitials from '../../helpers/nameInitials';
import SkeletonProcess from './skeletonProcess';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
import FormCreateActionPlanStatus from '../../components/performance/forms/formCreateActionPlanStatus';



export default function TakeDevelopmentPlan() {

    const [pageLoad, setPageLoad] = useState(true)

    const { id } = useParams()
    const [object, setObject] = useState('')
    const toast = useRef(null);
    const [currentSession, setCurrentSession] = useState('')
    const [currentActionPlan, setCurrentActionPlan] = useState('')
    const [currentActionPlanHistory, setCurrentActionPlanHistory] = useState('')


    const modalRef = useRef()
    const hideOffCanvas = () => {
        const elem = modalRef.current
        const modal = bootstrap.Offcanvas.getInstance(elem)
        modal.hide()
    }

    useEffect(() => {
        getObject()
        
    }, [])

    function getObject() {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id
        }
        performanceService.takeDevelopmentPlan(data).then((response) => {
            setObject(response)
            setCurrentSession(response.sessions[0])
        }).catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 })
        }).finally(() => {
            setPageLoad(false)
        })
    }

    function actionPlanType(value) {
        switch (value) {
            case 'CF':
                return 'Curso/Formação'
            case 'PR':
                return 'Projeto'
            case 'TR':
                return 'Trabalho'
            case 'TA':
                return 'Tarefa'
            case 'OU':
                return 'Outro'
        default:
            break;
    }
    }

    function getActionPlanStatus(value) {
        switch (value) {
            case 'NI':
                return 'Não Iniciado'
            case 'FA':
                return '1-25%'
            case 'FB':
                return '25-50%'
            case 'FC':
                return '50-75%'
            case 'FD':
                return '75-99%'
            case 'CS':
                return 'Completado'
        default:
            break;
    }
    }

    function confirmTakeDevelopmentPlan() {
        let data = {
            company_id: localStorage.getItem("companyId"),
            id: id
        }
        performanceService.confirmTakeDevelopmentPlan(data).then(() => {
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Plano de Desenvolvimento finalizado com sucesso', life: 5000 });
            getObject()
        }).catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 })
        })
    }

    return (
        <ProtectedRoute>

            <Toast ref={toast} position="top-right" />

            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <div className='col text-bg-green p-3'>
                        {
                            object?
                            <div className="fs-6 fw-bold ps-5 text-white">
                                {object.performance.title}
                            </div>
                            :
                            <>
                            <a href='/' className="fs-6 fw-bold ps-5 text-decoration-none text-white">
                                <FontAwesomeIcon className='' icon={solid('arrow-left')} /> Voltar
                            </a>
                            </>
                        }
                    </div>
                </div>
                {
                    object ?
                    <>
                    <div className='p-3 mt-4 mb-2 mx-5 bg-white contentShadowFull rounded'>
                        <div className='mb-2 border-bottom pb-2'>
                            <table className=''>
                                <tbody>
                                    <tr>
                                        <td className='pe-2'>
                                            {
                                                object.employee.user.photo ?
                                                <>
                                                <img src={object.employee.user.photo} alt="" height="50" className='rounded-circle' />
                                                </>
                                                :
                                                <Avatar label={NameInitials( object.employee.user.name )} style={{ backgroundColor: '#42c0fb', color: '#ffffff', fontWeight: 'bold' }} shape="circle" />
                                            }
                                        </td>
                                        <td className='pe-4'>
                                            <span className='fw-bold fs-6'>{object.employee.user.name}</span>
                                        </td>
                                        <td className='ps-4 border-start'>
                                                Seja bem vindo(a)!
                                                <br/>
                                                Altere os status para cada um dos planos de ação apresentados
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className=''>
                            
                            <table className='table table-sm table-borderless mb-0'>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span className='fw-bold'>Período:</span> {moment(object.performance.start_date).format("DD/MM/YYYY")} - {moment(object.performance.end_date).format("DD/MM/YYYY")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span className='fw-bold pe-2'>Status do Plano de Desenvolvimento:</span>
                                            {
                                                object.status === 'PE' || object.status === 'NI' ?
                                                <>
                                                <span className='bg-danger text-white bg-opacity-75 rounded-pill px-4 py-1 ms-1'>{object.statusDisplay}</span>
                                                </>
                                                :
                                                <span className='bg-success text-white bg-opacity-75 rounded-pill px-4 py-1 ms-1'>{object.statusDisplay}</span>
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className='d-flex justify-content-end'>
                                {
                                    object.checkQuestionsDone.check_done && object.status !== 'RE' ?
                                    <button className='btn btn-success text-white bg-opacity-75 rounded-pill px-4 py-1 ms-1' onClick={() => {confirmTakeDevelopmentPlan()}}>
                                        Finalizar PDI
                                    </button>
                                    :
                                    null
                                }
                            </div>
                    </div>
                    </>
                    :
                    null
                }
                <div className='d-flex mx-5 bg-white contentShadowFull rounded-top' style={{minHeight: '500px'}}>

                {
                    pageLoad ?
                    <SkeletonProcess />
                    :
                    <>
                    {
                        object ?
                        <>
                        <div className='col paddingBottom200'>
                        {
                            currentSession.session_type === 'QE' ?
                            <div className='mb-5'>
                            {
                                currentSession.questions.length > 0 ?
                                <>
                                <div className='p-3'>
                                {
                                    currentSession.questions.map((item, index) =>
                                    <div key={index} className='border rounded mb-2'>
                                        <div className='p-3'>
                                            <span className='fw-bold'>{index+1}.</span>
                                            <span className='fs-6 fw-normal' dangerouslySetInnerHTML={{ __html: item.question }}></span>
                                        </div>
                                        {
                                            item.actionPlans && item.actionPlans.length > 0 ?
                                            <div className=''>
                                                <table className='table border-top'>
                                                    <thead className='table-light'>
                                                        <tr>
                                                            <th colSpan={2}>Planos de Ação</th>
                                                            <th className='text-center'>Tipo</th>
                                                            <th className='text-center'>Status</th>
                                                            <th className='text-center'>Última Atualização</th>
                                                            <th className='text-center' colSpan={2}>Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                {
                                                    item.actionPlans.map((plan, idx) =>
                                                    <tr key={idx}>
                                                        <td width='10'>
                                                            <span className='fw-bold'>{idx+1}.</span>
                                                        </td>
                                                        <td className=''>
                                                            <span dangerouslySetInnerHTML={{__html: plan.action}}></span>
                                                        </td>
                                                        <td className='text-center'>
                                                            {actionPlanType(plan.actionType)}
                                                        </td>
                                                        <td className='text-center'>
                                                            {
                                                                plan.actionPlanStatus && plan.actionPlanStatus.length > 0 ?
                                                                <>
                                                                {
                                                                    plan.actionPlanStatus[0].status === 'CS' ?
                                                                    <>
                                                                    <FontAwesomeIcon className='text-green' icon={solid('circle-check')} /> {getActionPlanStatus(plan.actionPlanStatus[0].status)}
                                                                    </>
                                                                    :
                                                                    <>{getActionPlanStatus(plan.actionPlanStatus[0].status)}</>
                                                                }
                                                                </>
                                                                :
                                                                <>
                                                                <span>Não Iniciado</span>
                                                                </>
                                                            }
                                                        </td>
                                                        <td className='text-center'>
                                                        {
                                                                plan.actionPlanStatus && plan.actionPlanStatus.length > 0 ?
                                                                <>
                                                                <span>{moment(plan.actionPlanStatus[0].created).format("DD/MM/YYYY")}</span>
                                                                </>
                                                                :
                                                                <>
                                                                <span>Não Iniciado</span>
                                                                </>
                                                            }
                                                        </td>
                                                        <td className='text-center'>
                                                            {
                                                                plan.actionPlanStatus && plan.actionPlanStatus.length > 0 && plan.actionPlanStatus[0].status === 'CS' ?
                                                                <></>
                                                                :
                                                                <button className='btn btn-sm rounded-circle' data-bs-toggle="offcanvas" data-bs-target="#offCanvasActionPlan" onClick={() => {
                                                                    setCurrentActionPlan(plan)
                                                                }}>
                                                                    <FontAwesomeIcon className='text-green' icon={solid('pencil')} />
                                                                </button>
                                                            }
                                                            {
                                                                plan.actionPlanStatus && plan.actionPlanStatus.length > 0 ?
                                                                <span className='ms-2'>
                                                                    <button alt='Ver Histórico' className='btn btn-sm rounded-circle' data-bs-toggle="offcanvas" data-bs-target="#offCanvasActionPlanHistory"
                                                                    onClick={() => {
                                                                        setCurrentActionPlanHistory(plan.actionPlanStatus); setCurrentActionPlan(plan)
                                                                    }} >
                                                                        <FontAwesomeIcon className='text-green' icon={solid('history')} />
                                                                    </button>
                                                                </span>
                                                                :
                                                                null
                                                            }
                                                        </td>
                                                    </tr>
                                                    )
                                                }
                                                    </tbody>
                                                </table>
                                            </div>
                                            : null
                                        }
                                    </div>
                                    )
                                }
                                </div>
                                </>
                                :
                                <p>Nenhuma pergunta adicionada ainda</p>
                            }
                            </div>
                            : null
                        }
                        </div>
                        </>
                        :
                        <>Carregando...</>
                    }
                    </>
                }
                    
                </div>
            </div>
            <div ref={modalRef} className='offcanvas offcanvas-end offcanvas-size-xl' data-bs-backdrop="static" id='offCanvasActionPlan' tabIndex={-1}>
                <div className='offcanvas-header'>
                    <h6 className='offcanvas-title'>Status do Plano de Ação</h6>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className='offcanvas-body'>
                    <div className='p-3 bg-light rounded'>
                        {
                            currentActionPlan ?
                            <>
                            <div className='fw-bold'>Plano de Ação</div>
                            <p dangerouslySetInnerHTML={{__html: currentActionPlan.action}}></p>
                            <FormCreateActionPlanStatus actionPlan={currentActionPlan} getObject={getObject} hideOffCanvas={hideOffCanvas} />
                            </>
                            :
                            null
                        }
                    </div>
                </div>
            </div>

            <div  className='offcanvas offcanvas-end offcanvas-size-xl' data-bs-backdrop="static" id='offCanvasActionPlanHistory' tabIndex={-1}>
                <div className='offcanvas-header'>
                    <h6 className='offcanvas-title'>Histórico de Status do Plano de Ação</h6>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className='offcanvas-body'>
                    <div className='pt-3 p-1 bg-light rounded'>
                        {
                            currentActionPlanHistory ?
                            <>
                            <table className='table table-sm table-border'>
                            <thead className='borderBottom'>
                                <tr>
                                    <th>Descrição</th>
                                    <th className='text-center'>Status</th>
                                    <th className='text-center'>Data de Início</th>
                                    <th className='text-center'>Data de Término</th>
                                    <th className='text-center'>Arquivo</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                currentActionPlanHistory.map((item, index) =>
                                <tr key={index}>
                                    <td>
                                        <span>{item.description}</span>
                                    </td>
                                    <td className='text-center'>
                                        <span>{getActionPlanStatus(item.status)}</span>
                                    </td>
                                    <td className='text-center'>
                                        <span>{moment(item.start_date).format("DD/MM/YYYY")}</span>
                                    </td>
                                    <td className='text-center'>
                                        <span>{moment(item.end_date).format("DD/MM/YYYY")}</span>
                                    </td>
                                    <td className='text-center'>
                                        {
                                            item.file ? 
                                            <a href={item.file} className='text-blue' role='button' target='_blank' rel='noopener noreferrer'>
                                                <FontAwesomeIcon className='text-green' icon={solid('file')} />
                                            </a> 
                                            : <>-</>
                                        }
                                    </td>
                                </tr>
                                )
                            }
                            </tbody>
                            </table>
                            </>
                            :
                            null
                        }
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}